var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "signUpFrom", attrs: { id: "signUpContent" } },
    [
      _c("div", { staticClass: "logo" }),
      _vm._v(" "),
      !_vm.isTransfer
        ? _c("h2", { staticClass: "sign-title" }, [
            _vm._v(_vm._s(_vm.$t("language.login.signUpTitle")))
          ])
        : _c("h2", { staticClass: "sign-title" }, [
            _vm._v(
              _vm._s(_vm.$t("language.shareTransfers.signupTitleByTransfer"))
            )
          ]),
      _vm._v(" "),
      _c("hr", { staticClass: "sign-top-line" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "font14", staticStyle: { "margin-bottom": "17px" } },
        [
          _vm._v(_vm._s(_vm.$t("language.login.tips")) + "\n        "),
          _c(
            "span",
            {
              staticClass: "alink",
              on: {
                click: function($event) {
                  return _vm.toSignIn()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("language.login.logInButton")))]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mc-row" }, [
        _c(
          "label",
          {
            staticClass: "ic-label ic-email",
            class: _vm.inputClass(_vm.selectInput.email),
            attrs: { for: "" }
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.email,
                  expression: "email"
                }
              ],
              staticClass: "width100",
              class: _vm.inputClass(_vm.selectInput.email),
              attrs: {
                type: "text",
                name: "email",
                placeholder: _vm.$t("language.popup.email"),
                autoComplete: "off",
                id: "signUpEmail"
              },
              domProps: { value: _vm.email },
              on: {
                focus: function($event) {
                  return _vm.focusInput("email")
                },
                blur: function($event) {
                  return _vm.testEmail()
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.email = $event.target.value
                }
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "err tips-info",
            class: _vm.tipsClass(_vm.selectInput.email)
          },
          [_vm._v(_vm._s(_vm.tipsMsg.email))]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mc-row" }, [
        _c(
          "label",
          {
            staticClass: "ic-label ic-password",
            class: _vm.inputClass(_vm.selectInput.password),
            attrs: { for: "" }
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password"
                }
              ],
              ref: "passwordSignUp",
              staticClass: "width100",
              class: _vm.inputClass(_vm.selectInput.password),
              attrs: {
                type: "password",
                name: "password",
                autocomplete: "new-password",
                placeholder: _vm.$t("language.signUp.pwdTip"),
                id: "signUpPsd"
              },
              domProps: { value: _vm.password },
              on: {
                focus: function($event) {
                  return _vm.focusInput("password")
                },
                blur: function($event) {
                  return _vm.testPassword()
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.password = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "password-eye",
              class: _vm.showPassword ? "icon-eye" : "icon-eye-hide",
              on: {
                click: function($event) {
                  return _vm.checkShowPassword()
                }
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "err tips-info",
            class: _vm.tipsClass(_vm.selectInput.password)
          },
          [_vm._v(_vm._s(_vm.tipsMsg.password))]
        )
      ]),
      _vm._v(" "),
      _c("div", {
        ref: "turnstileContainer",
        staticClass: "turnstile-container"
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mc-row", style: _vm.isVCode ? "" : "display:none" },
        [
          _c(
            "label",
            {
              staticClass: "ic-label ic-verification f-dib width68",
              class: _vm.inputClass(_vm.selectInput.code),
              attrs: { for: "" }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.code,
                    expression: "code"
                  }
                ],
                staticClass: "width100",
                class: _vm.inputClass(_vm.selectInput.code),
                attrs: {
                  type: "text",
                  name: "verificationCode",
                  placeholder: _vm.$t("language.login.verificationCode"),
                  id: "signUpCode"
                },
                domProps: { value: _vm.code },
                on: {
                  focus: function($event) {
                    return _vm.focusInput("code")
                  },
                  blur: function($event) {
                    return _vm.testCode()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.code = $event.target.value
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "f-dib" }, [
            _c("img", {
              staticClass: "sign-verificationCode",
              attrs: { src: _vm.ficationCode },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.refreshAndClearCode()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "err tips-info",
              class: _vm.tipsClass(_vm.selectInput.code)
            },
            [_vm._v(_vm._s(_vm.tipsMsg.code))]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mc-row btn", staticStyle: { "margin-bottom": "20px" } },
        [
          _c(
            "p",
            {
              staticClass: "err tips-info",
              class: _vm.tipsClass(_vm.selectInput.btn),
              staticStyle: { position: "absolute", top: "-21px" }
            },
            [_vm._v(_vm._s(_vm.tipsMsg.btn))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "login-btn",
              class: _vm.selectInput.btn == "signing" ? "no-click" : "",
              on: {
                click: function($event) {
                  return _vm.signUp()
                }
              }
            },
            [
              _vm.selectInput.btn == "signing"
                ? _c("span", [
                    _vm._v(_vm._s(_vm.$t("language.signUp.signingUp")))
                  ])
                : _c("span", [
                    _vm._v(_vm._s(_vm.$t("language.login.createAccount")))
                  ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "login-thirdLogin" }, [
        _c("p", { staticClass: "thirdLogin-tip" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("language.login.continueWith")))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "thirdLogin" }, [
          _c(
            "button",
            {
              staticClass: "thirdLogin-btn",
              on: {
                click: function($event) {
                  return _vm.thirdLogin("facebook")
                }
              }
            },
            [_c("span", { staticClass: "sign-third-logo sign-facebook" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "thirdLogin-btn",
              on: {
                click: function($event) {
                  return _vm.thirdLogin("apple")
                }
              }
            },
            [_c("span", { staticClass: "sign-third-logo sign-apple" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "thirdLogin-btn",
              on: {
                click: function($event) {
                  return _vm.thirdLogin("google_drive")
                }
              }
            },
            [_c("span", { staticClass: "sign-third-logo sign-google" })]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "font13", staticStyle: { "text-align": "center" } },
        [
          _c("p", {
            staticClass: "f-margintop1",
            domProps: { innerHTML: _vm._s(_vm.$t("language.signUp.tips2")) }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "email-push-btn" }, [
        _c(
          "div",
          {
            staticClass: "email-push-check",
            on: {
              click: function($event) {
                return _vm.clickEmailPush()
              }
            }
          },
          [
            _c("div", {
              staticClass: "icon-check",
              class: _vm.emailPush ? "" : "icon-check-none"
            })
          ]
        ),
        _vm._v(" "),
        _c("p", { staticClass: "email-push-tip" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("language.signUp.emailPushTip")) +
              "\n        "
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-897dabe2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-897dabe2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/share_page_popups/sign_up_popup.vue
// module id = null
// module chunks = 